import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import plusZhCn from 'plus-pro-components/es/locale/lang/zh-cn';

import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {
    const zhCnLocales = {
      ...zhCn,
      ...plusZhCn
    };
    const locale = computed(() => zhCnLocales);
    return (_ctx, _cache) => {
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["locale"]);
    };
  }
});